import { Facebook, Instagram, Youtube } from "lucide-react";

const XIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>
);
const TikTokIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" /></svg>
);
const SpotifyIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden><path d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm5.5 17.3a.75.75 0 0 1-1.03.25c-2.82-1.72-6.37-2.11-10.55-1.16a.75.75 0 1 1-.33-1.46c4.57-1.04 8.5-.6 11.66 1.34.35.22.46.68.25 1.03zm1.47-3.27a.94.94 0 0 1-1.29.31c-3.23-1.98-8.15-2.56-11.97-1.4a.94.94 0 1 1-.54-1.8c4.36-1.32 9.78-.68 13.49 1.6.44.27.58.85.31 1.29zm.13-3.4C15.24 8.33 8.87 8.12 5.17 9.24a1.13 1.13 0 1 1-.65-2.16c4.25-1.29 11.31-1.04 15.76 1.6a1.13 1.13 0 0 1-1.18 1.95z" /></svg>
);
const PodcastIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden><path d="M12 2a10 10 0 0 0-3.5 19.37v-2.16A8 8 0 1 1 15.5 19.2v2.17A10 10 0 0 0 12 2zm0 4a6 6 0 0 0-2.5 11.46v-2.3A4 4 0 1 1 14.5 15.2v2.28A6 6 0 0 0 12 6zm0 4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm0 4.5c-1.1 0-2 .6-2 1.35V21c0 .55.9 1 2 1s2-.45 2-1v-4.65c0-.75-.9-1.35-2-1.35z" /></svg>
);

const LINKS = [
  ["tiktok_url", "TikTok", TikTokIcon, "hover:text-cyan-300"],
  ["youtube_channel", "YouTube", Youtube, "hover:text-rose-500"],
  ["instagram_url", "Instagram", Instagram, "hover:text-pink-400"],
  ["twitter_url", "X / Twitter", XIcon, "hover:text-white"],
  ["facebook_url", "Facebook", Facebook, "hover:text-blue-400"],
  ["spotify_url", "Spotify", SpotifyIcon, "hover:text-green-400"],
  ["apple_podcasts_url", "Apple Podcasts", PodcastIcon, "hover:text-purple-400"],
];

export const SocialLinks = ({ settings = {}, size = 18, className = "" }) => {
  const items = LINKS.filter(([key]) => settings[key]);
  if (!items.length) return null;
  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="social-links">
      {items.map(([key, label, Icon, hover]) => (
        <a key={key} href={settings[key]} target="_blank" rel="noreferrer" title={label} aria-label={label} className={`p-2 rounded-full text-slate-400 transition-colors duration-200 hover:bg-white/5 ${hover}`} data-testid={`social-link-${key.replace("_url", "").replace("_channel", "")}`}>
          <Icon size={size} />
        </a>
      ))}
    </div>
  );
};
